import { createContext, useContext } from 'react';

import type { PagePropertiesManager } from './page-properties-manager';

export const ManagerContext = createContext<PagePropertiesManager | null>(null);

export function useManager(): PagePropertiesManager {
  const manager = useContext(ManagerContext);
  if (!manager) {
    throw new Error('useManager must be used within ManagerContext');
  }
  return manager;
}
